var map = {
	"./App/index.tsx": 2649,
	"./AuthenticityCheck/index.tsx": 1101,
	"./TecDoc/index.tsx": 1134,
	"api/services/App/index.tsx": 2649,
	"api/services/AuthenticityCheck/index.tsx": 1101,
	"api/services/TecDoc/index.tsx": 1134
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6526;